import React from "react";
import { FormattedMessage } from "react-intl";
import { useCodeChallenges } from "hooks";
import { PrimaryButton } from "components/Buttons";

/**
 * CodeChallengeImportButton
 */
const CodeChallengeImportButton = () => {
  const { handleImportCodeChallenges, importing } = useCodeChallenges({ skip: true });

  return (
    <PrimaryButton disabled={importing} onClick={handleImportCodeChallenges}>
      <FormattedMessage id="CodeChallenges.CodeChallengeImportButton.Label" />
    </PrimaryButton>
  );
};

export default CodeChallengeImportButton;
